module.exports = __webpack_public_path__ + "static/media/microphone.dacf8e02.svg";